import React from 'react';
import { NavLink } from 'react-router-dom';
import AuthContext from '../../context/auth-context';
import './MainNavigation.css'

export default function MainNavigation() {
    return <AuthContext.Consumer>
        {(context) => {
            return (
                <header className="main-navigation">
                    <div className="main-navigation__logo">
                        <h1>Favorite Envents</h1>
                    </div>
                    <nav className="main-navigation__items">
                        <ul>
                            <li><NavLink to="/events">Events</NavLink></li>
                            {!context.token && (
                                <li><NavLink to="/auth">Login</NavLink></li>
                            )}
                            {context.token && (
                                <React.Fragment>
                                    <li>
                                        <NavLink to="/bookings">Bookings</NavLink>
                                    </li>
                                    <li>
                                        <button onClick={context.logout}>Logout</button>
                                    </li>
                                </React.Fragment>
                            )}
                        </ul>
                    </nav>
                </header>
            )
        }}
    </AuthContext.Consumer>
}